import React, { FC, SyntheticEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import logoImage from "../../assets/logo-top-left.svg";

export interface FooterProps {
  minimal?: boolean;
}
const Footer: FC<FooterProps> = ({ minimal = false }) => {
  const navigate = useNavigate();

  const handleNonFunctionalCTA = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate("/contact");
  };
  const navigateToTab = (path: string) => {
    return (e: React.MouseEvent) => {
      e.preventDefault();
      navigate(path);
    };
  };

  return (
    <footer className={`relative bg-gradient-to-b from-primary-white/0 to-primary-lightGreen/10 ${minimal ? "" : "border-t"} border-gray-100 transition-colors duration-300`}>
      <div className={`${minimal ? 'p-4' : 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14'}`}>
        {!minimal && (
          <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
            {/* Company Info */}
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center mb-4">
                <img
                  src={logoImage}
                  alt="Dhoondh Logo"
                  className="h-9 md:h-10 aspect-auto object-contain"
                  onError={(e: SyntheticEvent<HTMLImageElement, Event>) => {
                    e.currentTarget.style.display = "none";
                    if (e.currentTarget.nextSibling instanceof HTMLElement) {
                      e.currentTarget.nextSibling.style.display = "flex";
                    }
                  }}
                />
                <div
                  className="h-8 md:h-9 w-9 bg-primary-lightGreen rounded-xl flex items-center justify-center"
                  style={{ display: "none" }}
                >
                  <span className="text-primary-black font-bold text-lg">
                    D
                  </span>
                </div>
              </div>
              <p className="text-gray-600 mb-4 max-w-md">
                Post karo instantly and pao perfect match!
                <br />
                Dhoondh ke toh dekho...
              </p>
              <div className="flex space-x-4">
                {/* Instagram */}
                <a
                  href="https://www.instagram.com/dhoondh.in?igsh=MWp0OXN5aGE2MWZuYw%3D%3D&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-primary-lightGreen transition-colors"
                  aria-label="Instagram"
                >
                  <svg
                    className="h-6 w-6"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm10 2c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h10zm-5 3a6 6 0 100 12 6 6 0 000-12zm0 2a4 4 0 110 8 4 4 0 010-8zm6.5-.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z" />
                  </svg>
                </a>
                {/* WhatsApp */}
                <a
                  href="https://wa.me/919316846322"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-primary-lightGreen transition-colors"
                  aria-label="WhatsApp"
                >
                  <svg
                    className="h-6 w-6"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M20.52 3.48A11.94 11.94 0 0012.06.03C5.64.03.45 5.22.45 11.64c0 2.05.54 4.05 1.57 5.82L.02 24l6.69-2.02a11.7 11.7 0 005.35 1.34h.01c6.43 0 11.62-5.19 11.62-11.61 0-3.1-1.21-6.02-3.17-8.23zM12.07 21.2h-.01a9.55 9.55 0 01-4.86-1.31l-.35-.2-3.97 1.2 1.18-3.86-.23-.36a9.6 9.6 0 01-1.45-5.23C2.38 6.41 6.45 2.34 12.06 2.34c2.57 0 4.98 1 6.8 2.82a9.53 9.53 0 012.8 6.78c0 5.61-4.57 10.26-10.59 9.26z" />
                    <path d="M17.16 14.22c-.29-.14-1.72-.85-1.98-.95-.27-.1-.47-.14-.67.14-.2.29-.77.95-.94 1.15-.17.19-.35.21-.64.07-.29-.14-1.22-.45-2.33-1.44-.86-.77-1.44-1.72-1.6-2.01-.17-.29-.02-.45.12-.59.12-.12.29-.31.43-.46.15-.15.19-.26.29-.43.1-.19.05-.34-.02-.48-.07-.14-.67-1.62-.92-2.21-.24-.58-.48-.5-.67-.5l-.57-.01c-.2 0-.48.07-.73.34-.25.26-.96.94-.96 2.29s.98 2.66 1.12 2.85c.14.19 1.92 2.94 4.65 4.13.65.28 1.16.44 1.56.56.65.21 1.24.18 1.7.11.52-.08 1.72-.7 1.97-1.37.24-.67.24-1.23.17-1.37-.07-.14-.26-.22-.55-.36z" />
                  </svg>
                </a>
                {/* LinkedIn */}
                <a
                  href="https://www.linkedin.com/company/dhoondh-ltd/?viewAsMember=true"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-primary-lightGreen transition-colors"
                  aria-label="LinkedIn"
                >
                  <svg
                    className="h-6 w-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
              </div>
            </div>

            {/* For Candidates */}
            <div>
              <h3 className="text-lg font-semibold mb-4 text-primary-black ">
                For Candidates
              </h3>
              <ul className="space-y-2">
                <li>
                  <button
                    onClick={navigateToTab("/services")}
                    className="text-gray-600 hover:text-primary-black transition-colors text-left"
                  >
                    Browse Services
                  </button>
                </li>
                <li>
                  <button
                    onClick={navigateToTab("/register?isJobseeker=true")}
                    className="text-gray-600 hover:text-primary-black transition-colors text-left"
                  >
                    Create Profile
                  </button>
                </li>
                <li>
                  <button
                    onClick={navigateToTab("/user/dashboard")}
                    className="text-gray-600 hover:text-primary-black transition-colors text-left"
                  >
                    Candidate Dashboard
                  </button>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-gray-600 hover:text-primary-black transition-colors"
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* For Companies */}
            <div>
              <h3 className="text-lg font-semibold mb-4 text-primary-black ">
                For Companies
              </h3>
              <ul className="space-y-2">
                <li>
                  <button
                    onClick={navigateToTab("/register?isCompany=true")}
                    className="text-gray-600 hover:text-primary-black transition-colors text-left"
                  >
                    Register Company
                  </button>
                </li>
                <li>
                  <button
                    onClick={navigateToTab("/company/jobs")}
                    className="text-gray-600 hover:text-primary-black transition-colors text-left"
                  >
                    Post a Job
                  </button>
                </li>
                <li>
                  <button
                    onClick={navigateToTab("/company/dashboard")}
                    className="text-gray-600 hover:text-primary-black transition-colors text-left"
                  >
                    Company Dashboard
                  </button>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-gray-600 hover:text-primary-black transition-colors"
                  >
                    Contact Sales
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact & Newsletter */}
            <div>
              <h3 className="text-lg font-semibold mb-4 text-primary-black ">
                Stay in touch
              </h3>
              <ul className="space-y-2 mb-4">
                <li className="text-gray-600 ">Email:operations@dhoondh.in</li>
                <li className="text-gray-600 ">Phone: +91 93168 46322</li>
              </ul>
              <div className="flex flex-col w-full gap-3">
                <input
                  type="email"
                  name="email"
                  placeholder="Subscribe with your email"
                  className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-lightGreen"
                />
                <button
                  onClick={handleNonFunctionalCTA}
                  className="rounded-lg bg-primary-lightGreen px-4 py-2 text-sm font-semibold text-white hover:opacity-90 transition w-full"
                >
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="border-t border-gray-200 mt-10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-600 text-sm">
              © 2025 Dhoondh. All rights reserved.
              <br />
              AMPS DHOONDH RECRUITMENT LLP
            </p>

            <div className="flex space-x-6 mt-4 md:mt-0">
              <button
                onClick={navigateToTab("/privacy")}
                className="text-gray-600 hover:text-primary-black text-sm transition-colors"
              >
                Privacy
              </button>
              <button
                onClick={navigateToTab("/terms")}
                className="text-gray-600 hover:text-primary-black text-sm transition-colors"
              >
                Terms
              </button>
              <button
                onClick={navigateToTab("/cookies")}
                className="text-gray-600 hover:text-primary-black text-sm transition-colors"
              >
                Cookies
              </button>
              <button
                onClick={navigateToTab("/faq")}
                className="text-gray-600 hover:text-primary-black text-sm transition-colors"
              >
                FAQ
              </button>
              <button
                onClick={navigateToTab("/cancellation-refunds")}
                className="text-gray-600 hover:text-primary-black text-sm transition-colors"
              >
                Refunds
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
